import React from 'react';
import styles from './index.module.scss';

import { If } from 'utils';
import { ProtectedLink, UiKit } from 'components';
import { useSubscription } from 'utils/hooks';
import ADMIN_ROUTES from 'config/nav/admin/routes';

export default function ExternalCarriersBanner() {
  const { isByocStore } = useSubscription();

  const hasExternalCarriers = true;

  if (isByocStore) return null;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <span role="img" aria-label="info">
            ⚠️
          </span>{' '}
          Enable your external shipping carriers
        </div>
        <p className={styles.description}>
          <If test={hasExternalCarriers}>
            Your external carriers are currently disabled.{' '}
          </If>
          Switch to <strong>Bring Your Own Shipping Carriers</strong> plan to
          get access to your own carriers.
        </p>
      </div>
      <ProtectedLink
        to={ADMIN_ROUTES.SETTINGS.MANAGE_SUBSCRIPTION}
        _key="admin.submenu.settings.submenu.manage_subscription.enabled"
        className={styles.link}
      >
        <UiKit.Button className={styles.btn} size="sm" customType="outline">
          Switch Plan
        </UiKit.Button>
      </ProtectedLink>
    </div>
  );
}
